import { __decorate, __metadata } from "tslib";
import { ActivityEventType } from '@metaos/mfs-telemetry';
import { logActivity } from './logger';
import { getLocalStorage, getLocalStoreCapacityExceededError, hasCapacityExceeded } from './utility';
/** Class that has the implementation of MfsLocalStore that uses localStorage as its underlying implementation */
export class MfsWebLocalStore {
    constructor() {
        this.localStorage = getLocalStorage();
    }
    /** @inheritdoc */
    get(key) {
        return this.localStorage.getItem(key);
    }
    /** @inheritdoc */
    set(key, value) {
        try {
            this.localStorage.setItem(key, value);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (e) {
            if (hasCapacityExceeded(e)) {
                throw getLocalStoreCapacityExceededError();
            }
        }
    }
    /** @inheritdoc */
    removeEntry(key) {
        this.localStorage.removeItem(key);
    }
    /** @inheritdoc */
    clear() {
        this.localStorage.clear();
    }
}
__decorate([
    logActivity(ActivityEventType.SINGLE),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Object)
], MfsWebLocalStore.prototype, "get", null);
__decorate([
    logActivity(ActivityEventType.SINGLE),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], MfsWebLocalStore.prototype, "set", null);
__decorate([
    logActivity(ActivityEventType.SINGLE),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MfsWebLocalStore.prototype, "removeEntry", null);
__decorate([
    logActivity(ActivityEventType.SINGLE),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MfsWebLocalStore.prototype, "clear", null);
//# sourceMappingURL=mfsWebLocalStore.js.map